import { MessageState } from 'Modules/Communication/shared/models/Inbox'
import { RootState } from 'shared/store/store'
import { messageStateToInboxSectionEnum } from 'Modules/Communication/shared/util/messageStateHelper'

export const getSmsMessages = (state: RootState) =>
  state.communication?.smsMessages

export const getSmsSection = (state: RootState) =>
  state.communication.smsMessages.filters.queryStatus

export const getSmsFilters = (state: RootState) =>
  state.communication.smsMessages.filters

export const getSmsLabel = (state: RootState) =>
  state.communication.smsMessages.filters.labelId

export const getSmsMessagesMarkedForActions = (state: RootState) =>
  state.communication.smsMessages.marked
export const getSms = (state: RootState) => state.communication.smsMessages.sms

export const isSmsMarkedForAction = (id: string) => (state: RootState) =>
  state.communication.smsMessages.marked.includes(id)

export const getCurrentSms = (state: RootState) =>
  state.communication.smsMessages.sms.current

export const getSmsFromSmsMessagesById = (id: string) => (state: RootState) =>
  getSmsMessages(state)?.data?.result.find((sms) => sms.id === id)

export const getSingleListSmsActionId = (state: RootState) =>
  state.communication.smsMessages.singleListActionId

export const getCurrentSmsState =
  (currentId?: string) => (state: RootState) => {
    const email = getSms(state)
    if (!currentId) return null
    if (!email.current) return null

    const currentState = getSms(state).data.state || MessageState.Processed
    return messageStateToInboxSectionEnum(currentState)
  }
